import { render, staticRenderFns } from "./ParkingSpaceView.vue?vue&type=template&id=21c9bc7c&scoped=true&"
import script from "./ParkingSpaceView.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceView.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceView.vue?vue&type=style&index=0&id=21c9bc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9bc7c",
  null
  
)

export default component.exports